<template>
    <div class="bg-white px-3 index" >
        <el-tabs v-model="tabIndex" @tab-click="getList">
            <el-tab-pane :label="tab.name" :key="tabI" v-for="(tab, tabI) in tabbars">
                <div v-if="tab.key==1">
                    <nozzle></nozzle>
                </div>
                <div v-if="tab.key==2">
                    <menus></menus>
                </div>
                 <div v-if="tab.key==3">
                    <key></key>
                </div>
                 <div v-if="tab.key==4">
                    <follow></follow>
                </div>
                 <div v-if="tab.key==5">
                    <defaults></defaults>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import nozzle from '../../../components/paltform/nozzle.vue';
import menus from '../../../components/paltform/menu.vue';
import follow from '../../../components/paltform/follow.vue';
import defaults from '../../../components/paltform/default.vue';
import key from '../../../components/paltform/index.vue';
    export default {
        components:{
            nozzle,
            menus,
            follow,
            defaults,
            key
        },
        data() {
            return {
                tabIndex: "1",
                tabbars: [{
                        name: "接口设置",
                        key: 1
                    },
                    {
                        name: "菜单设置",
                        key: 2
                    },
                    {
                        name: "关键词回复",
                        key: 3
                    },
                    {
                        name: "关注回复",
                        key: 4
                    },
                    {
                        name: "默认回复",
                        key: 5
                    },
                ],
            }
        },
        methods:{
            getList(){

            },
        }
    }
</script>

<style>

</style>